import { Injectable } from '@angular/core';
import { CostumArray } from '../models/customArray';
import { RoomArray } from '../models/roomArray';
import { UserService } from './user.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ZoneArray } from '../models/zoneArray';


@Injectable({
  providedIn: 'root'
})
export class CommonMethodesService {

  roomList: Array<RoomArray>;
  selectedRoom: RoomArray | null = null
  zoneList: Array<ZoneArray>

  constructor(private userService: UserService) { }

  mapPlayroomsToUserList(playrooms: any[]): CostumArray[] {
    const userList: CostumArray[] = [];

    for (let i = 0; i < playrooms.length; i++) {
      let currentUserCustomObj = new CostumArray();
      currentUserCustomObj.value = playrooms[i].id.toString();
      currentUserCustomObj.display = playrooms[i].address.toString();

      const postoji = userList.some(
        u => u.display === currentUserCustomObj.display
      );

      if (!postoji) {
        userList.push(currentUserCustomObj);
      }
    }

    return userList;
  }

  mapPlayroomsToRoomList(playroom: any[], disp): RoomArray[] | any {

    var len = playroom?.length!;
    var i;

    this.roomList = []
    for (i = 0; i < len; i++) {
      let currentUserCustomObj = new RoomArray();
      currentUserCustomObj.value = playroom?.[i].id.toString()!;
      currentUserCustomObj.display = playroom?.[i].roomName.toString()!;
      console.log(disp)
       console.log(playroom[i].address)
      const postoji = playroom.some(
        u => disp === playroom[i].address
      );

      if (postoji) {
        this.roomList.push(currentUserCustomObj);
      }

    }
    return this.roomList;

  }

  getEmployeesByRoom(roomId: number, currentPage: number, itemsPerPage: number): Observable<any> {
    return this.userService.getAllUsersSub({ currentPage, itemsPerPage }).pipe(
      map(users => {
        const employees = users.filter(
          (user: any) => user.role === 'Employee' && user.room?.id === roomId
        );
        return employees;
      })
    );
  }


  mapPlayroomsToZoneList(zone: any[], disp): ZoneArray[] | any {

    var len = zone?.length!;
    var i;

    this.zoneList = []
    for (i = 0; i < len; i++) {
      if (disp === zone[i].roomName) {
        const z = new ZoneArray();
        z.value = zone[i].id.toString();
        z.display = zone[i].zoneName;
        this.zoneList.push(z);
      }
    }
    return this.zoneList;
  }

}
